import React from "react";

function Universe() {
    return (
        <div className="container mt-5">
            <div className="row mt-5">
                <h1 className="text-center mt-5">The Zerodha Universe</h1>
                <p className="text-center fs-5 mt-3">Extend your trading and investment experience even further with our partner platforms</p>
            </div>

            <div className="row mt-5">
                <div className="col-4">
                    <img src="media/smallcaseLogo.png" alt='logo' />
                    <p className="text-small text-muted">this is wonderful website created by me.
                    </p>
                </div>
                <div className="col-4">
                    <img src="media/smallcaseLogo.png" alt="logo" />
                    <p className="text-small text-muted">this is wonderful website created by me.
                    </p>
                </div>
                <div className="col-4">
                    <img src="media/smallcaseLogo.png" alt='logo' />
                    <p className="text-small text-muted">this is wonderful website created by me.
                    </p>
                </div>
            </div>


            <div className="row mt-5">
                <div className="col-4">
                    <img src="media/smallcaseLogo.png" alt='logo' />
                    <p className="text-small text-muted">this is wonderful website created by me.
                    </p>
                </div>
                <div className="col-4">
                    <img src="media/smallcaseLogo.png" alt="logo" />
                    <p className="text-small text-muted">this is wonderful website created by me.
                    </p>
                </div>
                <div className="col-4">
                    <img src="media/smallcaseLogo.png" alt='logo' />
                    <p className="text-small text-muted">this is wonderful website created by me.
                    </p>
                </div>
            </div>


            <div className="row mt-5">
                <div className="col-4">
                    <img src="media/smallcaseLogo.png" alt='logo' />
                    <p className="text-small text-muted">this is wonderful website created by me.
                    </p>
                </div>
                <div className="col-4">
                    <img src="media/smallcaseLogo.png" alt="logo" />
                    <p className="text-small text-muted">this is wonderful website created by me.
                    </p>
                </div>
                <div className="col-4">
                    <img src="media/smallcaseLogo.png" alt='logo' />
                    <p className="text-small text-muted">this is wonderful website created by me.
                    </p>
                </div>
                <button className='p-2 btn btn-primary fs-5 mb-5' style={{ width: "25%", margin: "0 auto" }}>Sign up for free</button>

            </div>
        </div>
    );
}

export default Universe;